import {
  Accordion,
  Card,
  Column,
  Heading,
  Row, Select, Spacer, Text
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import {
  GroupByHierarchyLevelType,
  IQuery,
  IQueryResult
} from 'common/interfaces/query';
import { useTranslation } from 'react-i18next';
import { QueryResult } from '../query-result/query-result';
import { TFunction } from 'i18next';
import { getDataTypeOptions } from '../query-utils';

interface IQueryResults {
  query: IQuery;
  queryResult: IQueryResult;
  isRunning: boolean;
  setQuery: any;
  setHierarchyData: any;
  setDataType: any;
}

const groupByOptions = Object.entries(GroupByHierarchyLevelType).map(([label, value]) => ({
  label,
  value,
}));

const hierarchyDataOptions = (t: TFunction, query: IQuery) => Object.values(GroupByHierarchyLevelType).filter(item => item !== query.groupBy).map((value) => ({
  label: t(translations[value]),
  value,
}));

const dataTypeOptions = getDataTypeOptions();

export const QueryResults = (
  {
    query,
    queryResult,
    isRunning,
    setQuery,
    setHierarchyData,
    setDataType,
  }: IQueryResults,
) => {
  const { t } = useTranslation();

  const setFilters = (filterValue: { [key: string]: string }) => {
    const updatedQuery = {
      ...query,
      resultConfig: { ...query.resultConfig, filters: { ...query?.resultConfig?.filters, ...filterValue } },
    };
    setQuery(updatedQuery);
  };

  return (
    <>
      <Card bordered={false}>
        <Accordion
          expanded
          managed
          heading={(
            <Heading>{t(translations.query_results)}</Heading>
          )}
        >
          <Row>
            <Column width={200}>
              <Text bold>{t(translations.query_groupBy)}</Text>
              <Spacer height="var(--padding-xxs)" />
              <Select
                value={query?.groupBy}
                options={groupByOptions}
                onChange={(event) => setQuery({ ...query, groupBy: event.target.value ?? '' })}
                clearable />
            </Column>
            <Column>
              <Text bold>Data type</Text>
              <Spacer height="var(--padding-xxs)" />
              <Select
                value={query?.dataType || []}
                options={dataTypeOptions}
                onChange={(event) => setDataType(event.target.value)}
                multi
                clearable />
            </Column>
          </Row>
          <Spacer height="var(--padding-xl)" />
          <Row>
            <Column>
              <Text bold>Hierarchy data</Text>
              <Spacer height="var(--padding-xxs)" />
              <Select
                value={query?.resultConfig?.hierarchy || []}
                options={hierarchyDataOptions(t, query)}
                onChange={(event) => setHierarchyData(event.target.value)}
                multi
                clearable />
            </Column>
          </Row>
          <Spacer height="var(--padding-xl)" />
          <QueryResult
            setFilters={setFilters}
            isRunning={isRunning}
            result={queryResult}
            query={query}
          />
        </Accordion>
      </Card>
    </>
  );
};

